import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { DialogConfirmComponent } from '@core/modules/dialogs/components/dialog-confirm/dialog-confirm.component';
import { DialogUploadComponent } from '@core/modules/dialogs/components/dialog-upload/dialog-upload.component';
import { SharedModule } from '@shared/shared.module';
import { DialogFilesDisplayComponent } from './components/dialog-files-display/dialog-files-display.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
	declarations: [DialogConfirmComponent, DialogUploadComponent, DialogFilesDisplayComponent],
	imports: [CommonModule, SharedModule, MatDividerModule, MatDialogModule, MatButtonModule, NzUploadModule, NzIconModule],
	exports: [DialogConfirmComponent, DialogUploadComponent, DialogFilesDisplayComponent],
})
export class DialogsModule {
	// Dialogs Module should only be imported once in the application
	constructor(@Optional() @SkipSelf() parentModule: DialogsModule) {
		if (parentModule) {
			throw new Error('DialogsModule is already loaded. Import it in the CoreModule only');
		}
	}
}
